"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useRef } from "react";
import { useLayout } from "../layout/LayoutContext";
import { useWave } from "@/hooks/useWave";
import type { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveTabsMeme from "./MyStreamWaveTabsMeme";
import MyStreamWaveTabsDefault from "./MyStreamWaveTabsDefault";
import useDeviceInfo from "../../../../hooks/useDeviceInfo";
import type { WaveViewMode } from "@/hooks/useWaveViewMode";
import type { ChatSubmitDropAction } from "../chatSubmitDrop.types";
interface MyStreamWaveTabsProps {
  readonly wave: ApiWave;
  readonly viewMode: WaveViewMode;
  readonly onToggleViewMode: () => void;
  readonly showGalleryToggle: boolean;
  readonly activeCurationId?: string | null | undefined;
  readonly onSelectCuration?: ((curationId: string | null) => void) | undefined;
  readonly chatSubmitDropAction?: ChatSubmitDropAction | null | undefined;
}
export const MyStreamWaveTabs: React.FC<MyStreamWaveTabsProps> = t0 => {
  const $ = _c(18);
  const {
    wave,
    viewMode,
    onToggleViewMode,
    showGalleryToggle,
    activeCurationId: t1,
    onSelectCuration: t2,
    chatSubmitDropAction: t3
  } = t0;
  const activeCurationId = t1 === undefined ? null : t1;
  const onSelectCuration = t2 === undefined ? _temp : t2;
  const chatSubmitDropAction = t3 === undefined ? null : t3;
  const {
    isMemesWave
  } = useWave(wave);
  const {
    registerRef
  } = useLayout();
  const {
    isApp
  } = useDeviceInfo();
  const tabsElementRef = useRef(null);
  let t4;
  let t5;
  if ($[0] !== isApp || $[1] !== registerRef) {
    t4 = () => {
      if (isApp) {
        registerRef("tabs", null);
      }
    };
    t5 = [isApp, registerRef];
    $[0] = isApp;
    $[1] = registerRef;
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  useEffect(t4, t5);
  let t6;
  if ($[4] !== registerRef) {
    t6 = element => {
      tabsElementRef.current = element;
      registerRef("tabs", element);
    };
    $[4] = registerRef;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const setTabsRef = t6;
  if (isApp) {
    return null;
  }
  let t7;
  if ($[6] !== activeCurationId || $[7] !== chatSubmitDropAction || $[8] !== isMemesWave || $[9] !== onSelectCuration || $[10] !== onToggleViewMode || $[11] !== showGalleryToggle || $[12] !== viewMode || $[13] !== wave) {
    t7 = <div className="tw-w-full tw-bg-iron-950"><div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-x-3">{isMemesWave ? <MyStreamWaveTabsMeme wave={wave} activeCurationId={activeCurationId} onSelectCuration={onSelectCuration} /> : <MyStreamWaveTabsDefault wave={wave} viewMode={viewMode} onToggleViewMode={onToggleViewMode} showGalleryToggle={showGalleryToggle} activeCurationId={activeCurationId} onSelectCuration={onSelectCuration} chatSubmitDropAction={chatSubmitDropAction} />}</div></div>;
    $[6] = activeCurationId;
    $[7] = chatSubmitDropAction;
    $[8] = isMemesWave;
    $[9] = onSelectCuration;
    $[10] = onToggleViewMode;
    $[11] = showGalleryToggle;
    $[12] = viewMode;
    $[13] = wave;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== setTabsRef || $[16] !== t7) {
    t8 = <div className="tw-flex-shrink-0" ref={setTabsRef} id="tabs-container">{t7}</div>;
    $[15] = setTabsRef;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
function _temp() {}